module.exports = __webpack_public_path__ + "static/media/seatPremierOne_787-9.c79a0d6d.png";